import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const Dashboard = ({ onLogout }) => {
    const username = localStorage.getItem('username') || 'utente';
    const navigate = useNavigate();

    const isAdmin = useMemo(() => {
        const u = String(username).toLowerCase();
        return u === 'admin' || u === 'giorgio';
    }, [username]);
    const initials = useMemo(() => String(username).slice(0, 1).toUpperCase(), [username]);

    const handleLogout = () => {
        onLogout();
        navigate('/login');
    };

    return (
        <div className="dashboard-shell">
            <header className="dashboard-hero">
                <div className="dashboard-hero-left">
                    <div className="dashboard-avatar" aria-hidden="true">{initials}</div>
                    <div>
                        <div className="dashboard-title">Dashboard</div>
                        <div className="dashboard-subtitle">
                            Connesso come <strong>{username}</strong>
                            <span className={`dashboard-badge ${isAdmin ? 'is-admin' : 'is-user'}`}>
                                {isAdmin ? 'Admin' : 'Utente'}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="dashboard-hero-right">
                    <button className="dashboard-btn secondary" onClick={() => navigate('/')}>Vai al sito</button>
                    <button className="dashboard-btn danger" onClick={handleLogout}>Logout</button>
                </div>
            </header>

            <main className="dashboard-body">
                <div className="dashboard-section-title">Gestione contenuti</div>
                <div className="dashboard-grid">
                    <button className="dashboard-card" onClick={() => navigate('/protectedProgetti')}>
                        <div className="dashboard-card-title">Progetti</div>
                        <div className="dashboard-card-desc">Modifica / aggiungi progetti e riordina per categoria.</div>
                    </button>

                    <button className="dashboard-card" onClick={() => navigate('/protectedFinanza')}>
                        <div className="dashboard-card-title">Finanza di Progetto</div>
                        <div className="dashboard-card-desc">Seleziona i progetti da mostrare e gestisci i contenuti.</div>
                    </button>

                    {isAdmin && (
                        <button className="dashboard-card" onClick={() => navigate('/protectedLogs')}>
                            <div className="dashboard-card-title">Registro attività</div>
                            <div className="dashboard-card-desc">Visualizza accessi e modifiche di tutti gli utenti.</div>
                        </button>
                    )}
                </div>

            </main>
        </div>
    );
};

export default Dashboard;